import { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@/components/ui';
import styles from '../MemberPerms.module.css';

// 말줄임된 게임 이름 — 실제로 잘렸을 때만 마우스 오버로 전체 이름을 말풍선으로 보여준다.
// 잘림 여부는 렌더 직후와 hover 시점에 다시 측정한다(폰트 swap·컬럼 폭 변화 대응).
export default function TruncatedName({ text }: { text: string }) {
  const ref = useRef<HTMLDivElement | null>(null);
  const [truncated, setTruncated] = useState(false);
  const measure = () => {
    // 실제 말줄임은 Tooltip 래퍼 안쪽 span에서 일어나므로 그 요소를 측정한다.
    const element = ref.current?.querySelector<HTMLElement>('span > span') ?? ref.current;
    if (element) setTruncated(element.scrollWidth > element.clientWidth + 1);
  };

  useEffect(() => {
    measure();
    const element = ref.current;
    if (!element) return;
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [text]);

  return <div ref={ref} className={styles.gameNameText} onMouseEnter={measure}>
    <Tooltip text={text} disabled={!truncated}><span>{text}</span></Tooltip>
  </div>;
}
